var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8025,
    cy: 23.5432,
    r: 23.5432,
    fill: "url(#paint0_radial_10_1376)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1313 26.0828H18.0747C17.9533 26.0826 17.8347 26.1191 17.7343 26.1873C17.6339 26.2555 17.5564 26.3524 17.5119 26.4654C17.4673 26.5783 17.4578 26.702 17.4846 26.8204C17.5114 26.9388 17.5732 27.0464 17.662 27.1291L26.0519 34.96C26.2962 35.1878 26.6178 35.3145 26.9519 35.3144H34.3451L31.1313 26.0828Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 9.09651H27.4004L18.853 34.4215C18.7652 34.6817 18.5979 34.9078 18.3748 35.068C18.1517 35.2282 17.884 35.3144 17.6093 35.3145H11.2015C10.9934 35.3145 10.7883 35.265 10.6031 35.17C10.418 35.075 10.2581 34.9373 10.1367 34.7683C10.0153 34.5992 9.93592 34.4037 9.90509 34.1979C9.87426 33.9921 9.89287 33.7819 9.9594 33.5848L17.9227 9.98951C18.0105 9.72917 18.1778 9.50293 18.401 9.34267C18.6241 9.18242 18.892 9.09621 19.1667 9.09619V9.09651Z",
    fill: "url(#paint1_linear_10_1376)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6831 9.98817C29.5954 9.72825 29.4284 9.50239 29.2055 9.34241C28.9827 9.18244 28.7153 9.0964 28.441 9.09644H19.2646C19.539 9.09645 19.8063 9.1825 20.0292 9.34247C20.252 9.50244 20.419 9.72828 20.5068 9.98817L28.4704 33.5844C28.537 33.7816 28.5556 33.9918 28.5248 34.1977C28.494 34.4035 28.4146 34.5991 28.2933 34.7682C28.1719 34.9373 28.012 35.0751 27.8268 35.1701C27.6416 35.2651 27.4364 35.3147 27.2283 35.3147H36.4049C36.6131 35.3146 36.8182 35.265 37.0033 35.17C37.1885 35.0749 37.3483 34.9372 37.4697 34.7681C37.591 34.599 37.6704 34.4034 37.7012 34.1976C37.7319 33.9918 37.7133 33.7816 37.6467 33.5844L29.6831 9.98817Z",
    fill: "url(#paint2_linear_10_1376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10_1376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2413 10.969) rotate(52.6646) scale(92.1962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_1376",
    x1: 22.1676,
    y1: 11.0394,
    x2: 13.6168,
    y2: 36.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_1376",
    x1: 23.7508,
    y1: 10.3025,
    x2: 33.1371,
    y2: 35.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.966ba44a384f9237477a82ed8cbec58a.svg";
export { ForwardRef as ReactComponent };